/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'
import { createSubscriptionDataIntervalSchema } from './CreateSubscriptionDataIntervalSchema'
import { createSubscriptionDataTierSchema } from './CreateSubscriptionDataTierSchema'

export const createSubscriptionDataSchema = z.object({
	tier: createSubscriptionDataTierSchema,
	interval: createSubscriptionDataIntervalSchema,
	paymentMethodId: z.string().uuid().nullable().optional(),
})

export type CreateSubscriptionDataSchema = z.infer<typeof createSubscriptionDataSchema>
